<template>
  <div>
    <!-- BootstrapVue Done -->
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-info">
      <b-row>
        <b-col xl="3" md="6">
          <stats-card
            type="gradient-info"
            icon="ni ni-chart-bar-32"
            class="mb-4"
          >
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPONDEN
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalAlumni }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card
            type="gradient-info"
            icon="ni ni-chart-bar-32"
            class="mb-4"
          >
            <h5 class="card-title text-uppercase text-muted mb-0">
              RESPON RATE
            </h5>
            <span class="h2 font-weight-bold mb-0">{{ totalMengisi }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--7">
      <b-row class="justify-content-center">
        <b-col lg="12">
          <card header-classes="bg-transparent">
            <!--Tables-->
            <b-row class="mt-2">
              <b-col xl="12" class="mb-5 mb-xl-0">
                <b-card body-class="p-0" header-class="border-0">
                  <template v-slot:header>
                    <b-row align-v="center">
                      <b-col>
                        <h3 class="mb-0" v-if="selected_tahun == ''">
                          Data Hasil Survey
                        </h3>
                        <h3 class="mb-0" v-else>
                          Data Hasil Survey {{ selected_tahun }}
                        </h3>
                      </b-col>
                      <!-- <b-col class="text-right">
                        <a href="#!" class="btn btn-sm btn-primary"><i class="ni ni-fat-add"></i>Tambah Data</a>
                      </b-col> -->
                    </b-row>
                  </template>

                  <div class="padding">
                    <!-- Inline Filter Bar (auto-apply) -->
                    <div class="filter-bar mb-3 p-3" style="background:#f8f9fa; border-radius:8px;">
                      <b-row class="align-items-end">
                        <b-col md="2" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Basis Tahun</label>
                          <select v-model="liveFilter.jns_tahun" class="form-control form-control-sm" @change="onLiveFilterChange">
                            <option value="kompre">Tahun Lulus / Kompre</option>
                            <option value="wisuda">Tahun Wisuda</option>
                          </select>
                        </b-col>
                        <b-col md="2" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Tahun</label>
                          <select v-model="liveFilter.tahun" class="form-control form-control-sm" @change="onLiveFilterChange">
                            <option value="">Semua</option>
                            <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun">{{ periode.tahun }}</option>
                          </select>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Fakultas</label>
                          <select v-model="liveFilter.id_fakultas" class="form-control form-control-sm" @change="onLiveFakultasChange">
                            <option value="">Semua Fakultas</option>
                            <option v-for="f in fakultas" :key="f.id_fakultas" :value="f.id_fakultas">{{ f.nm_fakultas }}</option>
                          </select>
                        </b-col>
                        <b-col md="3" sm="6" class="mb-2">
                          <label class="small font-weight-bold">Program Studi</label>
                          <select v-model="liveFilter.id_program_studi" class="form-control form-control-sm" @change="onLiveFilterChange">
                            <option value="">{{ liveFilter.id_fakultas ? 'Semua Prodi (di fakultas)' : 'Semua Prodi' }}</option>
                            <option v-for="p in liveFilteredProdi" :key="p.id_program_studi" :value="p.id_program_studi">
                              {{ p.jenjang }} - {{ p.nm_program_studi }}
                            </option>
                          </select>
                        </b-col>
                        <b-col md="2" sm="12" class="mb-2 text-right">
                          <b-button-group size="sm" class="w-100">
                            <b-button variant="outline-secondary" @click="resetLiveFilter" title="Reset filter">
                              <i class="fa fa-redo"></i>
                            </b-button>
                            <router-link to="/sync-onedata" class="btn btn-primary" title="Sync OneData">
                              <i class="fas fa-sync"></i>
                            </router-link>
                            <b-button variant="default" v-b-modal.modal-prevent-download title="Download Data">
                              <i class="fa fa-download"></i>
                            </b-button>
                          </b-button-group>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col md="6"></b-col>
                        <b-col md="6" class="text-right">
                          <small class="text-muted">
                            <span v-if="liveLoading"><i class="fa fa-spinner fa-spin"></i> Memuat...</span>
                            <span v-else>
                              <strong>{{ totalMengisi || 0 }}</strong> dari <strong>{{ totalAlumni || 0 }}</strong> alumni mengisi
                              <span class="ml-2 badge badge-success" v-if="totalAlumni > 0">{{ ((totalMengisi || 0) / totalAlumni * 100).toFixed(1) }}%</span>
                            </span>
                          </small>
                        </b-col>
                      </b-row>
                    </div>
                    <v-client-table
                      :data="tableData"
                      :columns="columns"
                      :options="options"
                    >
                      <template slot="no_pengisian" slot-scope="{ row }">
                        Pengisisan Ke- {{ row.no_pengisian }}
                      </template>
                      <template slot="status_mengisi" slot-scope="{ row }">
                        <button
                          v-if="row.status_mengisi == 1"
                          class="btn btn-sm btn-success"
                        >
                          sudah
                        </button>
                        <button
                          v-if="row.status_mengisi == 0"
                          class="btn btn-sm btn-danger"
                        >
                          belum
                        </button>
                      </template>
                      <template slot="actions" slot-scope="{ row }">
                        <button
                          @click="detailItem(row)"
                          class="btn btn-sm btn-info"
                        >
                          <i class="ni ni-curved-next mr-1"></i>detail
                        </button>
                      </template>
                    </v-client-table>
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <!--End tables-->
          </card>
        </b-col>
      </b-row>
    </b-container>
    <!-- modal filer-->
    <b-modal class="b-modal.modal-lg" id="modal-prevent-filter" ref="modal" title="Filter Data Hasil Tracer" >
      <div v-show="loading">
        <Loading />
      </div>
      <form>
        <div class="row">
          <div class="col-12">
            <label>Filter Tahun</label>
            <select
              name="id_tahun"
              class="form-control border text-left mr-2"
              v-model="selected_id_tahun"
            >
              <option value="" disabled="disabled">Pilih Filter Tahun</option>
              <option value="1">Lulusan/Kompre</option>
              <option value="2">Wisuda</option>
            </select>
          </div>
        </div>
        <div
          v-if="errors.has('id_tahun')"
          class="alert alert-danger rounded mb-3"
          role="alert"
        >
          Tahun Wajib diisi!
        </div>
        <div class="row mt-3" v-if="this.selected_id_tahun == 1 || this.selected_id_tahun == 2" >
          <div class="col-12">
            <label>Tahun</label>
            <select name="tahun" @change="getPrograms" class="form-control border text-left mr-2" v-model="selected_tahun" >
              <option value="" disabled="disabled">Pilih Tahun</option>
              <option
                v-for="periode in list_tahun_periode"
                :key="periode.tahun"
                :value="periode.tahun"
              >
                {{ periode.tahun }}
              </option>
            </select>
          </div>
        </div>
        <div
          v-if="errors.has('tahun')"
          class="alert alert-danger rounded mb-3"
          role="alert"
        >
          Tahun Wajib diisi!
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <label>Fakultas</label>
            <select
              name="id_fakultas"
              class="form-control border text-left mr-2"
              v-model="selected_fakultas"
              @change="onFakultasChangeFilter"
            >
              <option value="">Semua Fakultas</option>
              <option
                v-for="f in fakultas"
                :key="f.id_fakultas"
                :value="f.id_fakultas"
              >
                {{ f.nm_fakultas }}
              </option>
            </select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <label>Program Studi</label>
            <list-select
              :list="filteredStudyProgramsResult"
              option-value="id_program_studi"
              class="form-control border"
              option-text="nm_program_studi"
              :selected-item="selected_prodi"
              id="mySelectId"
              name="mySelectName"
              placeholder="Cari Program Studi"
              @select="getPrograms"
            ></list-select>
            <small v-if="selected_fakultas" class="text-muted">Hanya prodi dari fakultas terpilih</small>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- end-modal filter-->

    <!-- modal download-->
    <b-modal id="modal-prevent-download" ref="modal" size="lg" title="Download Data Hasil Tracer" @ok="handleOkDownload">
      <div v-show="loading_download" class="text-center py-3">
        <Loading />
      </div>

      <div class="info-banner-block mb-3">
        <div class="info-banner-icon"><i class="bx bx-info-circle"></i></div>
        <div class="info-banner-text">
          Format export sudah disesuaikan dengan rumus <strong>IKU 2 PDDIKTI 2025</strong> &mdash;
          bobot per kategori, pemetaan UMR daerah 1.2&times;, dan kolom akreditasi PT.
        </div>
      </div>

      <div class="text-right mb-3">
        <b-button @click="resetDownload()" size="sm" variant="outline-secondary" type="button">
          <i class="bx bx-reset"></i> Reset Filter
        </b-button>
      </div>

      <form @submit.prevent>
        <b-form-group label-class="font-weight-bold">
          <template #label>Jenis Download</template>
          <select name="jns_download" class="form-control" v-model="selected_download.jns_export">
            <option value="" disabled>-- Pilih Jenis Download --</option>
            <option value="iku">IKU 2 - Lulusan Produktif (PDDIKTI 2025)</option>
            <option value="upload_pddikti">Upload PDDIKTI / Akreditasi / Kebutuhan PT</option>
            <option value="riwayat_pengisian">Riwayat Pengisian Tracer</option>
          </select>
        </b-form-group>
        <div v-if="errors.has('jns_download')" class="alert alert-danger rounded py-2 small mb-3">
          Jenis Wajib diisi!
        </div>

        <b-form-group v-if="selected_download.jns_export === 'iku'" label-class="font-weight-bold">
          <template #label>
            Tahun Lulus IKU
            <small class="text-muted font-weight-normal">(default 2 tahun setelah lulus)</small>
          </template>
          <select name="tahun" class="form-control" v-model="selected_download.tahun">
            <option value="" disabled>-- Pilih Tahun Lulus --</option>
            <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun">
              Lulusan {{ periode.tahun }}
            </option>
          </select>
        </b-form-group>

        <template v-if="selected_download.jns_export && selected_download.jns_export !== 'iku'">
          <b-form-group label-class="font-weight-bold">
            <template #label>Filter Berdasarkan Tahun</template>
            <select name="id_tahun" class="form-control" v-model="selected_download.jns_tahun">
              <option value="" disabled>-- Pilih Jenis Tahun --</option>
              <option value="kompre">Tahun Lulus / Kompre</option>
              <option value="wisuda">Tahun Wisuda</option>
            </select>
            <small class="form-text text-muted">
              <em>Kompre</em> = tanggal lulus sidang. <em>Wisuda</em> = tanggal wisuda.
            </small>
          </b-form-group>

          <b-form-group v-if="selected_download.jns_tahun" label-class="font-weight-bold">
            <template #label>
              {{ selected_download.jns_tahun === 'wisuda' ? 'Tahun Wisuda' : 'Tahun Lulus / Kompre' }}
            </template>
            <select name="tahun" class="form-control" v-model="selected_download.tahun">
              <option value="" disabled>-- Pilih Tahun --</option>
              <option v-for="periode in list_tahun_periode" :key="periode.tahun" :value="periode.tahun">
                {{ periode.tahun }}
              </option>
            </select>
          </b-form-group>
          <div v-if="errors.has('tahun')" class="alert alert-danger rounded py-2 small mb-3">
            Tahun Wajib diisi!
          </div>
        </template>

        <b-form-group label-class="font-weight-bold">
          <template #label>Fakultas</template>
          <select name="faculty" @change="getProdi" class="form-control" v-model="selected_download.id_fakultas" v-validate="'required'">
            <option value="" disabled>-- Pilih Fakultas --</option>
            <option v-for="faculty in fakultas" :key="faculty.id_fakultas" :value="faculty.id_fakultas">
              {{ faculty.nm_fakultas }}
            </option>
          </select>
        </b-form-group>

        <b-form-group label-class="font-weight-bold">
          <template #label>Program Studi</template>
          <select name="study_program" class="form-control" v-model="selected_download.id_program_studi" v-validate="'required'">
            <option value="" disabled>-- Pilih Program Studi --</option>
            <option v-for="study_program in prodi" :key="study_program.id_program_studi" :value="study_program.id_program_studi">
              {{ study_program.jenjang }} - {{ study_program.nm_program_studi }}
            </option>
          </select>
        </b-form-group>
      </form>
    </b-modal>
    <!-- end-modal download-->
  </div>
</template>
<script>
import BaseHeader from "@/components/admin/BaseHeader";
import DataService from "@/services/data.service";
import Loading from "@/components/Loading.vue";
import { ListSelect } from "vue-search-select";

export default {
  name: "Alumni",
  components: {
    BaseHeader,
    Loading,
    ListSelect
  },
  data() {
    return {
      fakultas: [],
      prodi: [],
      selected_download: {
          jns_export: "",
          jns_tahun: "kompre",
          tahun: "",
          id_fakultas: "",
          id_program_studi: "",
      },
      selected_prodi: {
        id_program_studi: "",
        nm_program_studi: ""
      },
      selected_tahun: "",
      selected_fakultas: "",
      list_tahun_periode: {},
      study_programs: [],
      selected_id_tahun: "",
      // Inline live filter state
      liveFilter: {
        jns_tahun: 'kompre',
        tahun: '',
        id_fakultas: '',
        id_program_studi: ''
      },
      liveLoading: false,
      totalAlumni: "",
      totalMengisi: "",
      loading: false,
      loading_download: false,
      columns: [
        "wkt_pengisian",
        "no_pengisian",
        "id_alumni",
        "npm",
        "nama_lengkap",
        "nm_fakultas",
        "nm_program_studi",
        "tanggal_lulus",
        "tanggal_wisuda",
        "status_lulusan",
        "actions"
      ],
      tableData: [],
      options: {
        headings: {
          wkt_pengisian: "Waktu Pengisian  ",
          no_pengisian: "No Urut Pengisian  ",
          username: "NPM  ",
          nama_lengkap: "Nama Lengkap  ",
          nm_fakultas: "fakultas  ",
          nm_program_studi: "Program Studi  ",
          tanggal_lulus: "Tgl Lulus  ",
          tanggal_wisuda: "Tgl Wisuda  ",
          status_mengisi: "Status Lulusan ",
          actions: "Aksi "
        },
        sortable: true,
        filterable: false,
        hiddenColumns: ["id_alumni", "id_tracer"],
        texts: {
          count:
            "Menampilkan {from} sampai {to} dari {count} data|{count} data|Satu data",
          first: "Pertama",
          last: "Terahkir",
          filter: false,
          filterPlaceholder: "",
          limit: false,
          page: "Page:",
          noResults: "Data tidak ada",
          loading: "Loading...",
          defaultOption: "Select {column}",
          columns: "Columns"
        },
        sortIcon: {
          is: "fa fa-sort",
          base: "font-awesome",
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          align: "center"
        },
        pagination: {
          show: true,
          dropdown: false,
          chunk: 5,
          edge: false,
          align: "center",
          nav: "fixed"
        }
      }
    };
  },
  computed: {
    filteredStudyProgramsResult() {
      if (!this.selected_fakultas) return this.study_programs;
      var fak = this.selected_fakultas;
      return (this.study_programs || []).filter(function (sp) {
        return sp && sp.id_fakultas === fak;
      });
    },
    liveFilteredProdi() {
      if (!this.liveFilter.id_fakultas) return this.study_programs || [];
      var fak = this.liveFilter.id_fakultas;
      return (this.study_programs || []).filter(function (sp) {
        return sp && sp.id_fakultas === fak;
      });
    }
  },
  mounted() {
    var self = this;
    // Restore filter from sessionStorage (preserved across detail navigation)
    var saved = sessionStorage.getItem("hasil_tracer_filter");
    if (saved) {
      try {
        var parsed = JSON.parse(saved);
        self.liveFilter = Object.assign(self.liveFilter, parsed);
      } catch (e) { /* ignore */ }
    } else {
      self.liveFilter.tahun = String(new Date().getFullYear() - 1);
    }
    self.getTahun();
    self.getFakultas();
    self.getPs();
    self.applyLiveFilter();
  },
  methods: {
    onFakultasChangeFilter() {
      this.selected_prodi = { id_program_studi: "", nm_program_studi: "" };
    },
    onLiveFakultasChange() {
      // Reset prodi when fakultas changes
      this.liveFilter.id_program_studi = '';
      this.applyLiveFilter();
    },
    onLiveFilterChange() {
      this.applyLiveFilter();
    },
    resetLiveFilter() {
      this.liveFilter = {
        jns_tahun: 'kompre',
        tahun: String(new Date().getFullYear() - 1),
        id_fakultas: '',
        id_program_studi: ''
      };
      this.applyLiveFilter();
    },
    applyLiveFilter() {
      var self = this;
      self.liveLoading = true;
      // Persist filter so it survives navigation to/from detail page
      try { sessionStorage.setItem("hasil_tracer_filter", JSON.stringify(self.liveFilter)); } catch (e) { /* ignore */ }
      self.$store.commit("SHOW_LOADING", "Memuat hasil tracer...");
      DataService.getHasilTracer(self.liveFilter)
        .then(function (res) {
          self.tableData = res.data.surveys || [];
          self.totalAlumni = res.data.totalAlumni || 0;
          self.totalMengisi = res.data.totalMengisi || 0;
          self.liveLoading = false;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function () {
          self.liveLoading = false;
          self.$store.commit("HIDE_LOADING");
        });
    },
    detailItem(row) {
      this.$router.push({
        name: "detail-hasil-kuesioner",
        params: {
          id_alumni: row.id_alumni,
          id_tracer: row.id_tracer
        }
      });
    },
    downloadFile() {
      this.loading = true;
      if (this.selected_tahun === "") {
        this.$swal({ icon: "error", title: "Pilih tahun dahulu" });
        this.loading = false;
      } else {
        DataService.downloadFileTracer(
          this.selected_id_tahun,
          this.selected_tahun,
          this.selected_prodi.id_program_studi
        )
          .then(res => {
            this.customDownload(res, "HasilSurvey");
            this.loading = false;
          })
          .catch(error => console.error(error));
      }
    },
    customDownload(res, filename) {
      if (res.data) {
        this.loading = false;
      }
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([res.data], { type: "application/xlsx" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = data;
      link.download = filename + ".xlsx";
      link.click();
      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getTahun() {
      DataService.getTahunPeriode()
        .then(res => {
          this.list_tahun_periode = res.data.tahunPeriode;
        })
        .catch(error => console.error(error));
    },
    getFakultas(){
      DataService.getFaculties()
        .then(res => {
          this.fakultas = res.data.faculties;
        })
        .catch(error => console.error(error));
    },
    getProdi() {
      DataService.getProgramsChoise(this.selected_download.id_fakultas)
        .then(res => {
          this.prodi = res.data.studyPrograms;
        })
        .catch(error => console.error(error));
    },
    getPs() {
      DataService.getStudyProgramsJenjang()
        .then(res => {
          this.study_programs = res.data.studyPrograms;
        })
        .catch(error => console.error(error));
    },
    resetDownload() {
      this.selected_download = {
          jns_export: "",
          jns_tahun: "kompre",
          tahun: "",
          id_fakultas: "",
          id_program_studi: ""
      }
    },
    getPrograms(selected_prodi) {
      this.loading = true;
      if (this.selected_tahun === "") {
        this.$swal({
          icon: "error",
          title: "Pilih tahun dahulu"
        });
        this.loading = false;
      } else {
        this.selected_prodi = selected_prodi;
        DataService.getProgramStudyTracer(
          this.selected_id_tahun,
          this.selected_tahun,
          this.selected_prodi.id_program_studi
        )
          .then(res => {
            this.tableData = res.data.surveys;
            this.totalAlumni = res.data.totalAlumni;
            this.totalMengisi = res.data.totalMengisi;
            if (this.tableData) {
              this.loading = false;
              this.$nextTick(() => {
                this.$bvModal.hide("modal-prevent-filter");
              });
              return;
            }
          })
          .catch(error => console.error(error));
      }
    },
    getHasilTracer() {
      this.loading = true;
      this.$store.commit("SHOW_LOADING", "Memuat hasil kuesioner...");
      var filter = {
        tahun: this.selected_tahun || null,
        jns_tahun: this.selected_id_tahun === '2' ? 'wisuda' : 'kompre',
        id_fakultas: this.selected_fakultas || null,
        id_program_studi: this.selected_prodi && this.selected_prodi.id_program_studi ? this.selected_prodi.id_program_studi : null
      };
      DataService.getHasilTracer(filter).then(res => {
        this.tableData = res.data.surveys;
        this.totalAlumni = res.data.totalAlumni;
        this.totalMengisi = res.data.totalMengisi;
        this.loading = false;
        this.$store.commit("HIDE_LOADING");
      }).catch(() => {
        this.loading = false;
        this.$store.commit("HIDE_LOADING");
      });
    },
    getFilterTahun() {
      this.loading = true;
      DataService.getHasilTracerChoise(this.selected)
        .then(res => {
          this.tableData = res.data.surveys;
          this.totalAlumni = res.data.totalAlumni;
          this.totalMengisi = res.data.totalMengisi;
          if (this.tableData) {
            this.loading = false;
            return;
          }
        })
        .catch(error => console.error(error));
    },
    sinkronItem() {
      this.$swal({
        title: "Yakin ingin sinkron data?",
        text:
          "Sinkron data akan memakan waktu untuk proses dan Pastikan tidak ada perubahan data",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sinkron Sekarang!",
        cancelButtonText: "Batal"
      }).then(result => {
        this.loading = true;
        if (result.value) {
          DataService.getSinkronHasilTracer(this.selected)
            .then(response => {
              this.$swal("Data berhasil disetor");
              this.getHasilTracer();
            })
            .catch(error => {
              this.$swal({
                icon: "error",
                title: "Data gagal disetor"
              });
              this.getHasilTracer();
            });
        }
        // this.loading = false;
      });
    },
    handleOkDownload(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmitDownload();
    },
    handleSubmitDownload() {
      var self = this;
      var jns = self.selected_download.jns_export;
      // For IKU: only need tahun. For others: need jns_tahun + tahun.
      if (!jns) {
        self.$swal({ icon: "error", title: "Pilih Jenis Download" });
        return;
      }
      if (jns === 'iku' && !self.selected_download.tahun) {
        self.$swal({ icon: "error", title: "Pilih Tahun Lulus IKU" });
        return;
      }
      if (jns !== 'iku' && (!self.selected_download.jns_tahun || !self.selected_download.tahun)) {
        self.$swal({ icon: "error", title: "Pilih Jenis Tahun & Tahun" });
        return;
      }

      self.$nextTick(() => self.$bvModal.hide("modal-prevent-download"));
      self.loading = true;
      self.loading_download = true;
      var loadingLabel = jns === 'iku'
        ? 'Menyiapkan Excel IKU 2 (PDDIKTI 2025)...'
        : (jns === 'upload_pddikti' ? 'Menyiapkan Excel Upload PDDIKTI...' : 'Menyiapkan Excel Riwayat Pengisian...');
      self.$store.commit("SHOW_LOADING", loadingLabel);

      DataService.exportTracerStudy(self.selected_download)
        .then((res) => {
          self.customDownload(res, "HasilTracerStudy_" + jns + "_" + (self.selected_download.tahun || ''));
          self.loading = false;
          self.loading_download = false;
          self.$store.commit("HIDE_LOADING");
        })
        .catch((error) => {
          self.loading = false;
          self.loading_download = false;
          self.$store.commit("HIDE_LOADING");
          var msg = (error.response && error.response.data && error.response.data.message) || error.message || "Server error";
          self.$swal({ icon: "error", title: "Gagal mengunduh", text: msg });
        });
    },
  }
};
</script>
<style scoped>
.padding {
  padding: 20px !important;
}

/* Info banner — full width, text wraps with background covering all lines */
.info-banner-block {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: linear-gradient(135deg, #11cdef 0%, #1171ef 100%);
  color: #fff;
  border-radius: 8px;
  width: 100%;
  font-size: 0.85rem;
  line-height: 1.55;
  box-shadow: 0 2px 8px rgba(17, 113, 239, 0.2);
}
.info-banner-icon {
  flex-shrink: 0;
  font-size: 1.2rem;
  line-height: 1;
  padding-top: 2px;
}
.info-banner-text {
  flex: 1;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  color: #fff;
}
.info-banner-text strong {
  color: #fff;
  font-weight: 700;
}
@media (max-width: 480px) {
  .info-banner-block { font-size: 0.78rem; padding: 10px 12px; }
}
</style>
